export enum Domain {
    PLANNING = 1,
    CLASSROOM_ENVIRONMENT = 2,
    INSTRUCTION = 3,
    PROFESSIONAL_RESPONSIBILITIES = 4
}